/**
 * Carte interactive pour le bloc custom-content (Leaflet + OpenStreetMap).
 * Géocodage via Nominatim. Pins personnalisables par emplacement.
 */
(function () {
  'use strict';

  const NOMINATIM_URL = 'https://nominatim.openstreetmap.org/search';
  const GEOCODE_DELAY_MS = 1100; // respect Nominatim usage policy (1 req/sec)

  function getConfig(blockId) {
    const script = document.getElementById('custom-content-map-config-' + blockId);
    if (!script || !script.textContent) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function geocode(address) {
    const params = new URLSearchParams({
      q: address,
      format: 'json',
      limit: '1'
    });
    return fetch(NOMINATIM_URL + '?' + params.toString(), {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data[0]) {
          return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
        }
        return null;
      })
      .catch(function () { return null; });
  }

  function delay(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function addMarker(map, p, bounds) {
    const iconOpts = p.pin ? {
      iconUrl: p.pin,
      iconSize: [40, 40],
      iconAnchor: [20, 40],
      popupAnchor: [0, -40]
    } : null;
    const marker = L.marker([p.lat, p.lng], p.pin ? { icon: L.icon(iconOpts) } : {});
    marker.bindPopup(p.label || '');
    marker.addTo(map);
    bounds.push([p.lat, p.lng]);
  }

  function fitMapToBounds(map, bounds, zoom) {
    if (bounds.length > 1) {
      map.fitBounds(bounds, { padding: [20, 20], maxZoom: 15 });
    } else if (bounds.length === 1) {
      map.setView(bounds[0], zoom);
    }
  }

  function initMap(container) {
    const blockId = container.dataset.mapBlockId;
    if (!blockId || typeof L === 'undefined') return;

    const config = getConfig(blockId);
    const locations = (config && config.locations && Array.isArray(config.locations)) ? config.locations : [];
    const centerLat = parseFloat(container.dataset.mapCenterLat) || 48.8566;
    const centerLng = parseFloat(container.dataset.mapCenterLng) || 2.3522;
    const zoom = parseInt(container.dataset.mapZoom, 10) || 12;

    const map = L.map(container, { scrollWheelZoom: true }).setView([centerLat, centerLng], zoom);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);

    const bounds = [];

    // 1) Afficher immédiatement les points qui ont déjà lat/lng
    locations.forEach(function (loc) {
      const hasCoords = loc.lat !== '' && loc.lat != null && loc.lng !== '' && loc.lng != null &&
        !isNaN(parseFloat(loc.lat)) && !isNaN(parseFloat(loc.lng));
      if (hasCoords) {
        addMarker(map, {
          lat: parseFloat(loc.lat),
          lng: parseFloat(loc.lng),
          label: loc.label,
          pin: loc.pin
        }, bounds);
      }
    });
    if (bounds.length > 0) {
      fitMapToBounds(map, bounds, zoom);
    }

    // 2) Géocoder les adresses sans coordonnées et ajouter les marqueurs au fur et à mesure
    let geocodeIndex = 0;
    const toGeocode = locations.filter(function (loc) {
      const hasCoords = loc.lat !== '' && loc.lat != null && loc.lng !== '' && loc.lng != null &&
        !isNaN(parseFloat(loc.lat)) && !isNaN(parseFloat(loc.lng));
      return !hasCoords && loc.address && loc.address.trim() !== '';
    });

    function addNextGeocoded() {
      if (geocodeIndex >= toGeocode.length) return;
      const loc = toGeocode[geocodeIndex];
      const wait = geocodeIndex === 0 ? 0 : GEOCODE_DELAY_MS;
      geocodeIndex += 1;
      delay(wait).then(function () { return geocode(loc.address); }).then(function (coords) {
        if (coords) {
          addMarker(map, {
            lat: coords.lat,
            lng: coords.lng,
            label: loc.label,
            pin: loc.pin
          }, bounds);
          fitMapToBounds(map, bounds, zoom);
        }
        addNextGeocoded();
      });
    }
    addNextGeocoded();
  }

  function init() {
    if (typeof L === 'undefined') {
      setTimeout(init, 100);
      return;
    }
    document.querySelectorAll('.custom-content-map').forEach(function (el) {
      if (el.dataset.mapBlockId && !el.dataset.mapInited) {
        el.dataset.mapInited = '1';
        initMap(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
